import { render, staticRenderFns } from "./ReceivingOrderDetail.vue?vue&type=template&id=68766cf0&"
import script from "./ReceivingOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ReceivingOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingOrderDetail.vue?vue&type=style&index=0&id=68766cf0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68766cf0')) {
      api.createRecord('68766cf0', component.options)
    } else {
      api.reload('68766cf0', component.options)
    }
    module.hot.accept("./ReceivingOrderDetail.vue?vue&type=template&id=68766cf0&", function () {
      api.rerender('68766cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/ReceivingOrderDetail.vue"
export default component.exports